"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var ToggleOpen = /** @class */ (function () {
    function ToggleOpen(rootElement) {
        var _this = this;
        this.rootElement = rootElement;
        // Click event for toggle trigger to open element
        eventsHelper_1.default.live('.js-toggle-open', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            if (clickedElement.tagName === 'a' && clickedElement.getAttribute("href") === '') {
                // Prevent default for links
                event.preventDefault();
            }
            // Wait 50 ms before trigger
            setTimeout(function () {
                // If target is toggle trigger
                if (clickedElement) {
                    var elementId = clickedElement.dataset.elementId;
                    var element = _this.rootElement.querySelector('[data-element-id=' + elementId + ']:not(.js-toggle-open)');
                    var bodyElement = _this.rootElement.querySelector("body");
                    if (!element)
                        return;
                    if (!element.classList.contains('is-open')) {
                        element.classList.add('is-open');
                        bodyElement.classList.add(elementId + '-open');
                    }
                    else {
                        element.classList.remove('is-open');
                        bodyElement.classList.remove(elementId + '-open');
                    }
                }
            }, 50);
            return false;
        }, this.rootElement);
        rootElement.addEventListener('click', function (event) {
            var clickedElement = event.target;
            var bodyElement = rootElement.querySelector("body");
            // If not in sidebar and not toggle trigger
            if (clickedElement.classList && clickedElement.classList.contains('c-sidebar-container')) {
                var activeElements = rootElement.querySelectorAll('.is-open');
                if (activeElements.length) {
                    for (var i = 0; i < activeElements.length; i++) {
                        var activeElement = activeElements[i];
                        // Only remove is open on thoose which have data-element-id attribute
                        if (activeElement.hasAttribute('data-element-id')) {
                            // Does not remove if fixed
                            if (activeElement.classList.contains('is-open')) {
                                activeElement.classList.remove('is-open');
                                var elementId = activeElement.dataset.elementId;
                                bodyElement.classList.remove(elementId + '-open');
                            }
                        }
                    }
                }
            }
        });
    }
    return ToggleOpen;
}());
exports.default = ToggleOpen;
